<template>
  <div class="flex justify-center h-16 w-full bg-center bg-no-repeat col-span-3 col-start-3"
       :style="{ backgroundImage: `url(${computedArrowSrc})` }"
  >
    <div class="h-12 w-16 flex justify-center">
      <img v-if="iconSrc"
           :src="iconSrc"
           :alt="`${type} icon`"
           :height="iconHeight"
           class="mt-3"
           :class="iconClass"
      />
    </div>
  </div>
</template>

<script>
import { ANSWER_END } from '@/utils/bot-json.constants'
import arrowIconInactive from '@/assets/images/icons/ending_arrow_icon.svg'
import findIntentIcon from '@/assets/images/icons/find_intent_icon.svg'
import callOperatorIcon from '@/assets/images/icons/call_operator_icon.svg'
import waitInputThenIdleIcon from '@/assets/images/icons/wait_input_then_idle_icon.svg'
import continueConditionIcon from '@/assets/images/icons/continue_condition_icon.svg'
import continueBlockIcon from '@/assets/images/icons/continue_block_icon.svg'
import continueAnswerIcon from '@/assets/images/icons/continue_answer_icon.svg'

export default {
  name: 'AnswerEndArrow',

  props: {
    type: { type: String, required: true },
    arrowSrc: { type: String, default: null }
  },

  computed: {
    computedArrowSrc() {
      return this.arrowSrc || arrowIconInactive
    },

    iconSrc() {
      if (this.type === ANSWER_END.WAIT_INPUT_THEN_IDLE) return waitInputThenIdleIcon
      if (this.type === ANSWER_END.IDLE) return callOperatorIcon
      if (this.type === ANSWER_END.CONTINUE_CONDITION) return continueConditionIcon
      if (this.type === ANSWER_END.CONTINUE_TEMPLATE) return continueBlockIcon
      if (this.type === ANSWER_END.CONTINUE_ANSWER) return continueAnswerIcon
      if (this.type === ANSWER_END.FIND_INTENT) return findIntentIcon

      return null
    },

    iconHeight() {
      if (this.type === ANSWER_END.WAIT_INPUT_THEN_IDLE) return '23px'

      return '18px'
    },

    iconClass() {
      if (this.type === ANSWER_END.WAIT_INPUT_THEN_IDLE) return 'mr-1'

      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.bg-no-repeat {
  background-repeat: no-repeat
}

.bg-center {
  background-position: center
}
</style>
